var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-globals */
import React from 'react';
import classnames from 'classnames';
import { isObject } from '../../../../utils/object';
import { defaultNumberFormat } from '../../utils';
import { useColumnAndCellSelection } from './hooks';
export const CurrencyFormatter = React.memo((_a) => {
    var { value } = _a, props = __rest(_a, ["value"]);
    let displayValue = value;
    const { selectFullColumn, onSelection } = useColumnAndCellSelection(Object.assign(Object.assign({}, props), { value }));
    if (isObject(value) && !isNaN(value === null || value === void 0 ? void 0 : value.value))
        displayValue = value.value;
    const styleClass = displayValue < 0 ? 'negative-number' : 'number';
    return (React.createElement("div", { className: classnames('grid-table-base', {
            [styleClass]: !isNaN(displayValue),
            cell: isNaN(displayValue),
            'cell-selected': selectFullColumn,
        }), onClick: onSelection },
        React.createElement("div", { className: "currency" }, defaultNumberFormat(displayValue, 2))));
});
//# sourceMappingURL=CurrencyFormatter.js.map